import { render, staticRenderFns } from "./ResolucionesFirmar.vue?vue&type=template&id=22ad59fb&scoped=true"
import script from "./ResolucionesFirmar.vue?vue&type=script&lang=js"
export * from "./ResolucionesFirmar.vue?vue&type=script&lang=js"
import style0 from "./ResolucionesFirmar.vue?vue&type=style&index=0&id=22ad59fb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad59fb",
  null
  
)

export default component.exports